import { ReactNode } from 'react';

import { Box, BoxProps, Flex, FlexProps, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { SectionHeader } from '~/components/section-header';

export type StatsSectionProps = {
  bgGradient?: string;
  sectionPadding?: FlexProps['padding'];
  contentGap?: FlexProps['gap'];
  contentMaxWidth?: 'content-max-width' | 'content-max-width-lg' | 'content-max-width-md' | 'content-max-width-xl';
  headerIcon: ReactNode;
  headerSubtitle: string;
  headerTitle: ReactNode;
  headerDescription: ReactNode;
  headerColor?: string;
  children: ReactNode;
  footnote?: ReactNode;
  containerProps?: BoxProps;
};

export function StatsSection({
  bgGradient = 'linear(270deg, #001E65 0%, #0A0B0F 100%)',
  sectionPadding = { base: '56px 0px', md: '112px 0px' },
  contentGap = { base: '32px', md: '56px' },
  contentMaxWidth = 'content-max-width-md',
  headerIcon,
  headerSubtitle,
  headerTitle,
  headerDescription,
  headerColor = 'blue.300',
  children,
  footnote,
  containerProps,
}: StatsSectionProps) {
  return (
    <Box as='section' bgGradient={bgGradient} padding={sectionPadding}>
      <ContentContainer
        contentMaxWidth={contentMaxWidth}
        display='flex'
        flexDirection='column'
        gap={contentGap}
        {...containerProps}
      >
        <SectionHeader
          color={headerColor}
          descriptionSlot={headerDescription}
          iconSlot={headerIcon}
          subtitle={headerSubtitle}
          titleSlot={headerTitle}
        />
        {children}
        {footnote && (
          <Flex justifyContent='center'>
            {typeof footnote === 'string' ? (
              <Text color='white' size='caption' textAlign='center'>
                <Box as='sup'>*</Box>
                {footnote}
              </Text>
            ) : (
              footnote
            )}
          </Flex>
        )}
      </ContentContainer>
    </Box>
  );
}
